export default __webpack_public_path__ + "static/media/orders-empty.8dfb7718.svg";